module.exports = __webpack_public_path__ + "img/stock0.ab297846.png";